/* ============================================================
   CG LISTICLE — shared behaviour
   ------------------------------------------------------------
   Extracted from the monolithic sections/listicle.liquid.
   Loaded (defer) by the Countdown and Features sections.

   1. Countdown bar — daily-reset timer with a hard end date.
      Now initialises EVERY .cg-countdown on the page, not just the
      first one, so several countdown sections can coexist.
   2. Feature videos — play only while in view.

   Both initialisers are idempotent and re-run on
   shopify:section:load so they work inside the theme editor.
   ============================================================ */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function initCountdown(el) {
    var endDateAttr = el.getAttribute('data-end');
    var dailyReset = el.getAttribute('data-daily') === 'true';
    var hoursEl = el.querySelector('[data-cg-hours]');
    var minutesEl = el.querySelector('[data-cg-minutes]');
    var secondsEl = el.querySelector('[data-cg-seconds]');

    var finalEnd = endDateAttr ? new Date(endDateAttr + 'T23:59:59') : null;

    function getTarget() {
      if (dailyReset) {
        var midnight = new Date();
        midnight.setHours(24, 0, 0, 0);
        if (finalEnd && !isNaN(finalEnd.getTime()) && midnight > finalEnd) return finalEnd;
        return midnight;
      }
      return finalEnd;
    }

    var target = getTarget();
    if (!target || isNaN(target.getTime()) || new Date() >= target) {
      el.style.display = 'none';
      return;
    }

    var interval;
    function tick() {
      var now = new Date();
      var diff = target - now;
      if (diff <= 1000) {
        if (dailyReset && finalEnd && now < finalEnd) {
          target = getTarget();
          return;
        }
        el.style.display = 'none';
        clearInterval(interval);
        return;
      }
      var h = Math.floor(diff / 3600000); diff -= h * 3600000;
      var m = Math.floor(diff / 60000);   diff -= m * 60000;
      var s = Math.floor(diff / 1000);
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minutesEl) minutesEl.textContent = pad(m);
      if (secondsEl) secondsEl.textContent = pad(s);
    }
    tick();
    interval = setInterval(tick, 1000);
  }

  var videoObserver = null;
  function getVideoObserver() {
    if (videoObserver || !('IntersectionObserver' in window)) return videoObserver;
    videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.play().catch(function () {});
        else e.target.pause();
      });
    }, { threshold: 0.4 });
    return videoObserver;
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.cg-countdown[data-cg-countdown]'),
      function (el) {
        if (el.dataset.cgCountdownReady === 'true') return;
        el.dataset.cgCountdownReady = 'true';
        initCountdown(el);
      }
    );

    var io = getVideoObserver();
    if (!io) return;
    Array.prototype.forEach.call(
      document.querySelectorAll('.cg-listicle video[data-cg-autoplay]'),
      function (v) {
        if (v.dataset.cgAutoplayReady === 'true') return;
        v.dataset.cgAutoplayReady = 'true';
        io.observe(v);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
